<template>
    <div class="flex items-center h-full">                
        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-eye" class="mr-2" @click="hanldeViewSidebar"></vs-button>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'PreviewActions',
  mounted () {
    this.action = this.params.data.actionData
  },
  data () {
    return {
      action:{}
    }
  },
  methods: {
    ...mapActions(
      ['SET_DELETE_ID', 'SET_VIEW_LEADS_SIDEBAR', 'SET_VIEW_LEADS_SIDEBAR_DATA', 'SET_LEADS_TOGGLE_DATA']
    ),
    
    hanldeViewSidebar () {
      
      const viewbutton = true
      this.SET_VIEW_LEADS_SIDEBAR(true)
      this.SET_VIEW_LEADS_SIDEBAR_DATA(this.params.data)
      
    }
  }
}
</script>
